module.exports = __webpack_public_path__ + "img/mdi_youtube.3d8bffad.png";